import React from "react";
import { makeStyles } from "@mui/styles";
import { useMediaQuery } from "@mui/material";
import { Colors } from "../helpers/Colors";
import dyootiLogo from "../assets/images/logo/dyooti.svg";
import { display } from "@mui/system";
import { fontSize } from "../helpers/fontSize";
import { font } from "../helpers/font";
import { IoMdCall } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  Strip: {
    backgroundColor: Colors.primary,
    color: Colors.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 20px",
  },
  leftCon: {
    display: "flex",
    alignItems: "center",
    "& .docs": {
      fontSize: fontSize.paragraph,
      fontFamily: font.supreme,
      fontWeight: 500,
      padding: "0px 20px 0px 0px",
      cursor: "pointer",
    },
    "& #last": {
      padding: "0px 00px 0px 20px",
    },
  },
  rightCon: {
    display: "flex",
    fontSize: fontSize.pageNav,
    fontWeight: 700,
    "& .pageNav": {
      padding: "0px 5px 0px 5px",
      cursor: "pointer",
    },
    "& #last": {
      //   padding: "0px 0px 0px 20px",
    },
    "& .iconCon": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "20px",
      height: "18px",
      cursor: "pointer",
    },
  },
});

const Strip = ({ user, isSuperAdmin }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const onBookingFormClick = () => {
    navigate("/reservation");
  };
  const onAllReservationsClick = () => {
    navigate("/allReservations");
  };
  const onAddCabinClick = () => {
    navigate("/addCabin");
  };
  const onMyCabinsClick = () => {
    navigate("/myCabins");
  };
  const onMyReservationsClick = () => {
    navigate("/myReservations");
  };
  return (
    <main className={classes.Strip}>
      <section className={classes.leftCon}>
        <div className="docs">DOCS</div>
        {user && (
          <div className="docs" id="last" onClick={onBookingFormClick}>
            BOOKING FORM
          </div>
        )}
        {isSuperAdmin && (
          <>
            <div className="docs" id="last" onClick={onAllReservationsClick}>
              ALL RESERVATIONS
            </div>
            <div className="docs" id="last" onClick={onAddCabinClick}>
              ADD A CABIN
            </div>
            <div className="docs" id="last" onClick={onMyCabinsClick}>
              MY CABINS
            </div>
          </>
        )}
        {user && (
          <div className="docs" id="last" onClick={onMyReservationsClick}>
            MY RESERVATIONS
          </div>
        )}
      </section>
      <section className={classes.rightCon}>
        <div>CALL US TODAY:</div>
        <div className="pageNav" id="last">
          123-456-7890
        </div>
        <div className="iconCon">
          <IoMdCall className="icon" />
        </div>
      </section>
    </main>
  );
};

export default Strip;
